import {DataRequest} from "../../Cirrus/tlDataServices/DataRequest";
import {DataResponse} from "../../Cirrus/tlDataServices/DataResponse";
import {TriarcData} from "../../Cirrus/tlDataServices/UrlFunctions";
import * as angular from 'angular';
    export interface IVersionVm  { 
        version: number;
        versionName: string;
        versionCode: string;
        isBeta: boolean;
        platform: string;
    }
    export interface IImageData  { 
        bytes: string;
        name: string;
        mimeType: string;
    }
    export interface ILocationVm  { 
        key: number;
        locationId: string;
        name: string;
        emergencyPin: string;
        description: string;
        userId: string;
        userName: string;
    }
    export interface ITypeAheadModel  { 
        label: string;
        id: number;
        externalId: number;
        externalType?:EExternalProjectType;
    }
    export interface IEmployeeCm  { 
        id: number;
        lastName: string;
        firstName: string;
        email: string;
        externalId: number;
        profileId?:number;
        defaultProjectExternlId?:number;
        managementLevel: string;
        claimConfigurations: IFeatureConfigurationVm[];
    }
    export interface IEmployeeVm  { 
        id: number;
        firstName: string;
        lastName: string;
        externalId: number;
        canLogout: boolean;
        defaultProject: IAssignedProjectVm;
        assignedProjects: IAssignedProjectVm[];
        claims: string[];
    }
    export interface IProjectPersonVm  { 
        personId: number;
        firstName: string;
        lastName: string;
        isManual: boolean;
        externalId: string;
        chief: boolean;
    }
    export interface IFeatureConfigurationVm  { 
        featureClaim: IFeatureClaimVm;
    }
    export interface IAssignedProjectVm  { 
        id: number;
        externalId: number;
        name: string;
        type: EExternalProjectType;
    }
    export interface IFeatureClaimVm  { 
        claim: string;
        description: string;
        id: number;
        name: string;
    }
    export interface ISignParam  { 
        employeeId: number;
        day: Date;
    }
    export interface ICreateStampVm  { 
        id: string;
        employeeId: number;
        typeId: number;
        projectId: number;
        projectType?:EExternalProjectType;
        locationId?:number;
        fixedPositionNumber?:number;
        elapsedSeconds: number;
        stampType: EStampType;
        clientTimeStamp: Date;
    }
    export interface IAppUser  { 
        profileId: string;
        appUserType: EAppUserType;
        person: IEmployeeCm;
        location: ILocationVm;
        appConfig: IAppConfig;
        terminalId: string;
        isAdmin: boolean;
        loginName: string;
        timeEntryTypeSelectable: boolean;
        defaultEntryTypeId?:number;
        mustResetPassword: boolean;
    }
    export interface IMobileUser  { 
        appUserType: EAppUserType;
        person: IEmployeeVm;
        location: ILocationVm;
        appConfig: IAppConfig;
        loginName: string;
        timeEntryTypeSelectable: boolean;
        defaultEntryTypeId?:number;
        mustResetPassword: boolean;
    }
    export interface IUserVm  { 
        id: string;
        userName: string;
        userType: EAppUserType;
        locationId?:number;
        personId?:number;
        email: string;
        terminalid: string;
        password: string;
        oldPassword: string;
        passwordConfirm: string;
        linkedName: string;
        timeEntryTypeSelectable: boolean;
        defaultEntryTypeId?:number;
        lastPing?:Date;
    }
    export interface IUserInfoViewModel  { 
        userName: string;
        hasRegistered: boolean;
        loginProvider: string;
    }
    export interface IManageInfoViewModel  { 
        localLoginProvider: string;
        userName: string;
        logins: IUserLoginInfoViewModel[];
        externalLoginProviders: IExternalLoginViewModel[];
    }
    export interface IExternalLoginViewModel  { 
        name: string;
        url: string;
        state: string;
    }
    export interface ILoginViewModel  { 
        username: string;
        password: string;
        rememberMe: boolean;
    }
    export interface IChangePasswordBindingModel  { 
        id: number;
        oldPassword: string;
        newPassword: string;
        confirmPassword: string;
    }
    export interface ISetPasswordBindingModel  { 
        id: number;
        newPassword: string;
        confirmPassword: string;
    }
    export interface IAddExternalLoginBindingModel  { 
        externalAccessToken: string;
    }
    export interface IRemoveLoginBindingModel  { 
        loginProvider: string;
        providerKey: string;
    }
    export interface IRegisterVm  { 
        id: number;
        userName: string;
        password: string;
        confirmPassword: string;
    }
    export interface IRegisterExternalBindingModel  { 
        userName: string;
    }
    export interface IAppConfig  { 
        bookingTimeout: number;
    }
    export interface IUserLoginInfoViewModel  { 
        loginProvider: string;
        providerKey: string;
    }
    export interface IKeyVaulePair  { 
        key: string;
        value: string;
    }
    export interface ITimeRecorderConfiguration  { 
        downloadServer: string;
        defaultPassword: string;
        serverVersion: string;
        versionBase: string;
        maxBookingDurationHours: number;
        rabbitMqHost: string[];
        rabbitMqVirtualHost: string;
        rabbitMqUsername: string;
        rabbitMqPassword: string;
        rabbitMqPort: number;
        mLinkAddress: string;
        mLinkToken: string;
        mqCertPath: string;
        mqCertPassPhrase: string;
        mqCertThumbprint: string;
        mqCertHostName: string;
        mqPrefix: string;
    }
    export interface IRequeBookingsModel  { 
        day: number;
        month: number;
        year: number;
    }
    export interface IProfileConfigVm  { 
        name: string;
        description: string;
        id: number;
        userCount: number;
        featureConfigurations: IFeatureConfigurationVm[];
        isDefault: boolean;
    }
    export interface ITimesheetCm  { 
        days: IGeneralTimeSheetDayCm[];
        timesheetEmployees: ITimesheetEmployeeCm[];
        costCenter: string;
        costCenterExternalId: number;
        sheetType: ESheetType;
    }
    export interface ITimeSheetDayCm  { 
        dayTotal: number;
        isSigned: boolean;
        entries: ITimeSheetEntryCm[];
        plannedStart?:Date;
        project: string;
        travelTime?:number;
        vehicleLocation: string;
        vehicleNumber: string;
        pointOfDeparture: IAddressVm;
        effectiveStart: Date;
        breakTotal: number;
        date: Date;
        hasError: boolean;
        rules: IRulesPerDay;
    }
    export interface ITimesheetSearchCriteria  { 
        skip?:number;
        take?:number;
        plannedTimeFilterType?:PlannedTimeFilterType;
        employeeId?:number;
        projectId: number;
        from: Date;
        to: Date;
    }
    export interface IGeneralTimeSheetDayCm  { 
        date: Date;
        hasError: boolean;
        rules: IRulesPerDay;
    }
    export interface ITimesheetEmployeeCm  { 
        id: number;
        firstName: string;
        lastName: string;
        externalId: number;
        days: ITimeSheetDayCm[];
    }
    export interface ITimeSheetEntryCm  { 
        from: Date;
        to: Date;
        durationMinutes: number;
        isOpen: boolean;
        id: string;
    }
    export interface IAddressVm  { 
        street1: string;
        street2: string;
        city: string;
        postCode: string;
        abbreviation: string;
    }
    export interface IRulesPerDay  { 
        brokenRules: IBrokenRule[];
    }
    export interface IBrokenRule  { 
        ruleType: TimeRuleType;
        brokenType: BrokenRuleType;
        problem: string;
    }
    export interface IChangeSetVm  { 
        changeTime: Date;
        changedBy: string;
        changes: IChangeVm[];
    }
    export interface IChangeVm  { 
        fieldName: string;
        oldValue: string;
        newValue: string;
    }
    export interface IConfigVm  { 
        id: number;
        timeOut: number;
        imageId?:number;
    }
    export interface ISaveConfigVm  { 
        timeOut: number;
        saveImage: boolean;
        bytes: string;
        fileName: string;
        fileType: string;
    }
    export interface ILicenceStatusVm  { 
        licenceKey: string;
        totalLicences: number;
        licencesInUse: number;
        isValid: boolean;
        publicKey: string;
    }
    export interface ITimeRulesConfigVm  { 
        id: number;
        projectId?:number;
        project: ITypeAheadModel;
        type: ETimeRuleType;
        rules: ITimeRuleVm[];
        employeePermissions: IEmployeePermissionVm[];
    }
    export interface ITimeRuleVm  { 
        id: number;
        type: TimeRuleType;
        duration?:number;
        startString: string;
        endString: string;
        min?:number;
        max?:number;
    }
    export interface IEmployeePermissionVm  { 
        employee: ITypeAheadModel;
    }
    export interface ITimeBookingVm  { 
        id: string;
        from: Date;
        to?:Date;
        externalId?:number;
        projectId?:number;
        employeeId: number;
        project: ITypeAheadModel;
        employee: ITypeAheadModel;
        timeEntryTypeId?:number;
        timeEntryType: ITypeAheadModel;
        status: EStatus;
        errorMessage: string;
    }
    export interface ITimeBookingDetailVm  { 
        fromStamp: ITimeStampVm;
        toStamp: ITimeStampVm;
        projectType: EExternalProjectType;
        id: string;
        from: Date;
        to?:Date;
        externalId?:number;
        projectId?:number;
        employeeId: number;
        project: ITypeAheadModel;
        employee: ITypeAheadModel;
        timeEntryTypeId?:number;
        timeEntryType: ITypeAheadModel;
        status: EStatus;
        errorMessage: string;
    }
    export interface ITimeBookingSearchCirteria  { 
        projectId?:number;
        employeeId?:number;
        from?:Date;
        to?:Date;
        take: number;
        skip: number;
        eStatus?:EStatus;
        costCentreExternalId?:number;
    }
    export interface IBrowseModel  { 
        employeeId: number;
        skip: number;
        take: number;
    }
    export interface IBookingImportConditions  { 
        typeId?:number;
        employeeId?:number;
        ids: string[];
        externalIds: number[];
    }
    export interface ITimeStampVm  { 
    }
    export interface ICreateAbsenceVm  { 
        employeeId: number;
        from: Date;
        to: Date;
        typeId: number;
        locationId?:number;
    }
    export interface IExpenseVm  { 
        id: number;
        amount: number;
        employeeId: number;
        projectId: number;
        status: EStatus;
        project: ITypeAheadModel;
        expenseText: string;
        errorMessage: string;
        expenseType: ExpenseType;
        date: Date;
        image: string;
        imageName: string;
        imageMimeType: string;
    }
    export interface ICreateExpenseVm  { 
        amount: number;
        employeeId: number;
        projectType?:EExternalProjectType;
        projectId: number;
        date: Date;
        image: string;
        fileName: string;
        fileType: string;
        expenseText: string;
        expenseType: ExpenseType;
    }
    export interface ITimeEntryTypeVm  { 
        id: number;
        name: string;
        externalId: number;
        kind: EKind;
        unit: ETransmissionUnit;
    }
    export enum EPlatform {
        Android = 0,
        Ios = 1,
    }
    export enum EExternalProjectType {
        Proj = 0,
        Svm = 1,
    }
    export enum EStampType {
        Start = 1,
        Stop = 2,
        StartError = 3,
        StopError = 4,
        Fixed = 5,
    }
    export enum EAppUserType {
        WebOnly = 0,
        Terminal = 1,
        Personal = 2,
    }
    export enum ESheetType {
        Controlling = 0,
        CarPool = 1,
    }
    export enum PlannedTimeFilterType {
        TooEarly = 0,
        TooLate = 1,
        NoTravelTime = 2,
    }
    export enum TimeRuleType {
        AllocatedTime = 0,
        LunchBreak = 1,
    }
    export enum BrokenRuleType {
        DrasticProblem = 0,
        NotEnough = 1,
        TooMuch = 2,
        NoTravelTimeAvailable = 3,
    }
    export enum ETimeRuleType {
        Workcontrolling = 0,
        CarPool = 1,
    }
    export enum EStatus {
        Pending = 0,
        Success = 1,
        Failed = 2,
    }
    export enum DayOfWeek {
        Sunday = 0,
        Monday = 1,
        Tuesday = 2,
        Wednesday = 3,
        Thursday = 4,
        Friday = 5,
        Saturday = 6,
    }
    export enum DateTimeKind {
        Unspecified = 0,
        Utc = 1,
        Local = 2,
    }
    export enum ExpenseType {
        Default = 0,
        CarKilometers = 1,
        MotorCycleKilometers = 2,
    }
    export enum EKind {
        Work = 0,
        Absence = 1,
        Marina = 2,
    }
    export enum ETransmissionUnit {
        Hours = 1,
        Days = 2,
    }
    export interface VersionGetLatestPlistParams {
        versionCode1 : number;
        versionCode2 : number;
        versionCode3 : number;
    }
    export interface VersionGetLatestVersionNumberParams {
        includeBetas : boolean;
        platform? : EPlatform;
    }
    export interface VersionGetVersionsEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IVersionResource {
        getLatestPlistRequest (params: VersionGetLatestPlistParams ) : DataRequest<any>;
        getLatestPlist(params: VersionGetLatestPlistParams ) : angular.IPromise<DataResponse<any>>;
        getLatestVersionNumberRequest (params: VersionGetLatestVersionNumberParams ) : DataRequest<IVersionVm>;
        getLatestVersionNumber(params: VersionGetLatestVersionNumberParams ) : angular.IPromise<DataResponse<IVersionVm>>;
        getServerVersionRequest ( ) : DataRequest<string>;
        getServerVersion( ) : angular.IPromise<DataResponse<string>>;
        getVersionsMultipleRequest (params: VersionGetVersionsEnumerableParams ) : DataRequest<IVersionVm[]>;
        getVersionsMultiple(params: VersionGetVersionsEnumerableParams ) : angular.IPromise<DataResponse<IVersionVm[]>>;
        getDownloadLocationRequest ( ) : DataRequest<string>;
        getDownloadLocation( ) : angular.IPromise<DataResponse<string>>;
        newVersionVm(): IVersionVm;
    };
    export class VersionResource implements IVersionResource {
        constructor(private $requestSender) {}
                getLatestPlistRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Version/GetLatestPlist";
        if(angular.isDefined(params.versionCode1)) {
            url = TriarcData.appendUrlParameter(url, "versionCode1", encodeURIComponent(params.versionCode1));
        }
        if(angular.isDefined(params.versionCode2)) {
            url = TriarcData.appendUrlParameter(url, "versionCode2", encodeURIComponent(params.versionCode2));
        }
        if(angular.isDefined(params.versionCode3)) {
            url = TriarcData.appendUrlParameter(url, "versionCode3", encodeURIComponent(params.versionCode3));
        }
        var dataRequest = new DataRequest<any>("GET", url, {}, "Version", "any", false);
        return dataRequest;
    }
            getLatestPlist
(params) {     var request = this.        getLatestPlistRequest(params);
    return this.$requestSender.requestValue(request);
}
getLatestVersionNumberRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Version/GetLatestVersionNumber";
if(angular.isDefined(params.includeBetas)) {
    url = TriarcData.appendUrlParameter(url, "includeBetas", encodeURIComponent(params.includeBetas));
}
if(angular.isDefined(params.platform)) {
    url = TriarcData.appendUrlParameter(url, "platform", encodeURIComponent(params.platform));
}
var dataRequest = new DataRequest<IVersionVm>("GET", url, {}, "Version", "IVersionVm", false);
return dataRequest;
}
getLatestVersionNumber
(params) { var request = this.getLatestVersionNumberRequest(params);
return this.$requestSender.requestValue(request);
}
getServerVersionRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Version/GetServerVersion";
var dataRequest = new DataRequest<string>("GET", url, {}, "Version", "string", false);
return dataRequest;
}
getServerVersion
() { var request = this.getServerVersionRequest();
return this.$requestSender.requestValue(request);
}
getVersionsMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Version/GetVersions";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IVersionVm[]>("GET", url, {}, "Version", "IVersionVm[]", false);
return dataRequest;
}
getVersionsMultiple
(params) { var request = this.getVersionsMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
getDownloadLocationRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Version/GetDownloadLocation";
var dataRequest = new DataRequest<string>("GET", url, {}, "Version", "string", false);
return dataRequest;
}
getDownloadLocation
() { var request = this.getDownloadLocationRequest();
return this.$requestSender.requestValue(request);
}
public newVersionVm(): IVersionVm {
    return <IVersionVm>{};
}
}
    export interface ImageGetParams {
        imgId : number;
    }
    export interface ImageGetImageDataParams {
        imgId : number;
    }
    export interface IImageResource {
        getRequest (params: ImageGetParams ) : DataRequest<any>;
        get(params: ImageGetParams ) : angular.IPromise<DataResponse<any>>;
        getImageDataRequest (params: ImageGetImageDataParams ) : DataRequest<IImageData>;
        getImageData(params: ImageGetImageDataParams ) : angular.IPromise<DataResponse<IImageData>>;
        newImageData(): IImageData;
    };
    export class ImageResource implements IImageResource {
        constructor(private $requestSender) {}
                getRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Image/Get";
        if(angular.isDefined(params.imgId)) {
            url = TriarcData.appendUrlParameter(url, "imgId", encodeURIComponent(params.imgId));
        }
        var dataRequest = new DataRequest<any>("GET", url, {}, "Image", "any", false);
        return dataRequest;
    }
            get
(params) {     var request = this.        getRequest(params);
    return this.$requestSender.requestValue(request);
}
getImageDataRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Image/GetImageData";
if(angular.isDefined(params.imgId)) {
    url = TriarcData.appendUrlParameter(url, "imgId", encodeURIComponent(params.imgId));
}
var dataRequest = new DataRequest<IImageData>("GET", url, {}, "Image", "IImageData", false);
return dataRequest;
}
getImageData
(params) { var request = this.getImageDataRequest(params);
return this.$requestSender.requestValue(request);
}
public newImageData(): IImageData {
    return <IImageData>{};
}
}
    export interface LocationGetLocationByIdParams {
        id : string;
    }
    export interface LocationGetParams {
        id : number;
    }
    export interface LocationGetEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface LocationFlatSearchEnumerableParams {
        search : string;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface LocationSearchEnumerableParams {
        search : string;
        skip : number;
        take : number;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface LocationDeleteParams {
        id : number;
    }
    export interface ILocationResource {
        getLocationByIdRequest (params: LocationGetLocationByIdParams ) : DataRequest<ILocationVm>;
        getLocationById(params: LocationGetLocationByIdParams ) : angular.IPromise<DataResponse<ILocationVm>>;
        getRequest (params: LocationGetParams ) : DataRequest<ILocationVm>;
        get(params: LocationGetParams ) : angular.IPromise<DataResponse<ILocationVm>>;
        getMultipleRequest (params: LocationGetEnumerableParams ) : DataRequest<ILocationVm[]>;
        getMultiple(params: LocationGetEnumerableParams ) : angular.IPromise<DataResponse<ILocationVm[]>>;
        flatSearchMultipleRequest (params: LocationFlatSearchEnumerableParams ) : DataRequest<ITypeAheadModel[]>;
        flatSearchMultiple(params: LocationFlatSearchEnumerableParams ) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        searchMultipleRequest (params: LocationSearchEnumerableParams ) : DataRequest<ILocationVm[]>;
        searchMultiple(params: LocationSearchEnumerableParams ) : angular.IPromise<DataResponse<ILocationVm[]>>;
        putRequest ( data: ILocationVm) : DataRequest<any>;
        put( data: ILocationVm) : angular.IPromise<DataResponse<any>>;
        deleteRequest (params: LocationDeleteParams ) : DataRequest<any>;
        delete(params: LocationDeleteParams ) : angular.IPromise<DataResponse<any>>;
        newLocationVm(): ILocationVm;
        newTypeAheadModel(): ITypeAheadModel;
    };
    export class LocationResource implements ILocationResource {
        constructor(private $requestSender) {}
                getLocationByIdRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Location/GetLocationById";
        if(angular.isDefined(params.id)) {
            url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
        }
        var dataRequest = new DataRequest<ILocationVm>("GET", url, {}, "Location", "ILocationVm", false);
        return dataRequest;
    }
            getLocationById
(params) {     var request = this.        getLocationByIdRequest(params);
    return this.$requestSender.requestValue(request);
}
getRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Location/GetOne";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<ILocationVm>("GET", url, {}, "Location", "ILocationVm", false);
return dataRequest;
}
get
(params) { var request = this.getRequest(params);
return this.$requestSender.requestValue(request);
}
getMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Location/Get";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ILocationVm[]>("GET", url, {}, "Location", "ILocationVm[]", false);
return dataRequest;
}
getMultiple
(params) { var request = this.getMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
flatSearchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Location/FlatSearch";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITypeAheadModel[]>("POST", url, {}, "Location", "ITypeAheadModel[]", false);
return dataRequest;
}
flatSearchMultiple
(params) { var request = this.flatSearchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
searchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Location/Search";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.skip)) {
    url = TriarcData.appendUrlParameter(url, "skip", encodeURIComponent(params.skip));
}
if(angular.isDefined(params.take)) {
    url = TriarcData.appendUrlParameter(url, "take", encodeURIComponent(params.take));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ILocationVm[]>("POST", url, {}, "Location", "ILocationVm[]", false);
return dataRequest;
}
searchMultiple
(params) { var request = this.searchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
putRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Location/Put";
var dataRequest = new DataRequest<any>("POST", url, data, "Location", "any", true);
return dataRequest;
}
put
(data) { var request = this.putRequest(data);
return this.$requestSender.requestValue(request);
}
deleteRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Location/Delete";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("POST", url, {}, "Location", "any", false);
return dataRequest;
}
delete
(params) { var request = this.deleteRequest(params);
return this.$requestSender.requestValue(request);
}
public newLocationVm(): ILocationVm {
    return <ILocationVm>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
}
    export interface EmployeeGetEmployeeByIdParams {
        id : string;
    }
    export interface EmployeeGetProjectEmployeeParams {
        id : number;
    }
    export interface EmployeeGetProjectEmployeeByExternalidParams {
        externalId : number;
    }
    export interface EmployeeGetProjectEmployeesEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface EmployeeGetParams {
        id : number;
    }
    export interface EmployeeGetEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface EmployeeDeleteParams {
        id : number;
    }
    export interface EmployeeFlatSearchEnumerableParams {
        search : string;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface EmployeeSearchEnumerableParams {
        search : string;
        skip : number;
        take : number;
        profileId? : number;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface EmployeeSearchProjectPersonsEnumerableParams {
        search : string;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IEmployeeResource {
        getEmployeeByIdRequest (params: EmployeeGetEmployeeByIdParams ) : DataRequest<IEmployeeCm>;
        getEmployeeById(params: EmployeeGetEmployeeByIdParams ) : angular.IPromise<DataResponse<IEmployeeCm>>;
        getProjectEmployeeRequest (params: EmployeeGetProjectEmployeeParams ) : DataRequest<IEmployeeVm>;
        getProjectEmployee(params: EmployeeGetProjectEmployeeParams ) : angular.IPromise<DataResponse<IEmployeeVm>>;
        getProjectEmployeeByExternalidRequest (params: EmployeeGetProjectEmployeeByExternalidParams ) : DataRequest<IEmployeeVm>;
        getProjectEmployeeByExternalid(params: EmployeeGetProjectEmployeeByExternalidParams ) : angular.IPromise<DataResponse<IEmployeeVm>>;
        getProjectEmployeesMultipleRequest (params: EmployeeGetProjectEmployeesEnumerableParams ) : DataRequest<IEmployeeVm[]>;
        getProjectEmployeesMultiple(params: EmployeeGetProjectEmployeesEnumerableParams ) : angular.IPromise<DataResponse<IEmployeeVm[]>>;
        getRequest (params: EmployeeGetParams ) : DataRequest<IEmployeeCm>;
        get(params: EmployeeGetParams ) : angular.IPromise<DataResponse<IEmployeeCm>>;
        getMultipleRequest (params: EmployeeGetEnumerableParams ) : DataRequest<IEmployeeCm[]>;
        getMultiple(params: EmployeeGetEnumerableParams ) : angular.IPromise<DataResponse<IEmployeeCm[]>>;
        updateRequest ( data: IEmployeeCm) : DataRequest<any>;
        update( data: IEmployeeCm) : angular.IPromise<DataResponse<any>>;
        deleteRequest (params: EmployeeDeleteParams ) : DataRequest<any>;
        delete(params: EmployeeDeleteParams ) : angular.IPromise<DataResponse<any>>;
        flatSearchMultipleRequest (params: EmployeeFlatSearchEnumerableParams ) : DataRequest<ITypeAheadModel[]>;
        flatSearchMultiple(params: EmployeeFlatSearchEnumerableParams ) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        searchMultipleRequest (params: EmployeeSearchEnumerableParams ) : DataRequest<IEmployeeCm[]>;
        searchMultiple(params: EmployeeSearchEnumerableParams ) : angular.IPromise<DataResponse<IEmployeeCm[]>>;
        searchProjectPersonsMultipleRequest (params: EmployeeSearchProjectPersonsEnumerableParams ) : DataRequest<IProjectPersonVm[]>;
        searchProjectPersonsMultiple(params: EmployeeSearchProjectPersonsEnumerableParams ) : angular.IPromise<DataResponse<IProjectPersonVm[]>>;
        newEmployeeCm(): IEmployeeCm;
        newEmployeeVm(): IEmployeeVm;
        newTypeAheadModel(): ITypeAheadModel;
        newProjectPersonVm(): IProjectPersonVm;
        newAssignedProjectVm(): IAssignedProjectVm;
        newFeatureClaimVm(): IFeatureClaimVm;
    };
    export class EmployeeResource implements IEmployeeResource {
        constructor(private $requestSender) {}
                getEmployeeByIdRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Employee/GetEmployeeById";
        if(angular.isDefined(params.id)) {
            url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
        }
        var dataRequest = new DataRequest<IEmployeeCm>("GET", url, {}, "Employee", "IEmployeeCm", false);
        return dataRequest;
    }
            getEmployeeById
(params) {     var request = this.        getEmployeeByIdRequest(params);
    return this.$requestSender.requestValue(request);
}
getProjectEmployeeRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/GetProjectEmployee";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<IEmployeeVm>("GET", url, {}, "Employee", "IEmployeeVm", false);
return dataRequest;
}
getProjectEmployee
(params) { var request = this.getProjectEmployeeRequest(params);
return this.$requestSender.requestValue(request);
}
getProjectEmployeeByExternalidRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/GetProjectEmployeeByExternalid";
if(angular.isDefined(params.externalId)) {
    url = TriarcData.appendUrlParameter(url, "externalId", encodeURIComponent(params.externalId));
}
var dataRequest = new DataRequest<IEmployeeVm>("GET", url, {}, "Employee", "IEmployeeVm", false);
return dataRequest;
}
getProjectEmployeeByExternalid
(params) { var request = this.getProjectEmployeeByExternalidRequest(params);
return this.$requestSender.requestValue(request);
}
getProjectEmployeesMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/GetProjectEmployees";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IEmployeeVm[]>("GET", url, {}, "Employee", "IEmployeeVm[]", false);
return dataRequest;
}
getProjectEmployeesMultiple
(params) { var request = this.getProjectEmployeesMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
getRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/Get";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<IEmployeeCm>("GET", url, {}, "Employee", "IEmployeeCm", false);
return dataRequest;
}
get
(params) { var request = this.getRequest(params);
return this.$requestSender.requestValue(request);
}
getMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/Get";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IEmployeeCm[]>("GET", url, {}, "Employee", "IEmployeeCm[]", false);
return dataRequest;
}
getMultiple
(params) { var request = this.getMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
updateRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/Update";
var dataRequest = new DataRequest<any>("POST", url, data, "Employee", "any", true);
return dataRequest;
}
update
(data) { var request = this.updateRequest(data);
return this.$requestSender.requestValue(request);
}
deleteRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/Delete";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("POST", url, {}, "Employee", "any", false);
return dataRequest;
}
delete
(params) { var request = this.deleteRequest(params);
return this.$requestSender.requestValue(request);
}
flatSearchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/FlatSearch";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITypeAheadModel[]>("GET", url, {}, "Employee", "ITypeAheadModel[]", false);
return dataRequest;
}
flatSearchMultiple
(params) { var request = this.flatSearchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
searchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/Search";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.skip)) {
    url = TriarcData.appendUrlParameter(url, "skip", encodeURIComponent(params.skip));
}
if(angular.isDefined(params.take)) {
    url = TriarcData.appendUrlParameter(url, "take", encodeURIComponent(params.take));
}
if(angular.isDefined(params.profileId)) {
    url = TriarcData.appendUrlParameter(url, "profileId", encodeURIComponent(params.profileId));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IEmployeeCm[]>("POST", url, {}, "Employee", "IEmployeeCm[]", false);
return dataRequest;
}
searchMultiple
(params) { var request = this.searchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
searchProjectPersonsMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Employee/SearchProjectPersons";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IProjectPersonVm[]>("POST", url, {}, "Employee", "IProjectPersonVm[]", false);
return dataRequest;
}
searchProjectPersonsMultiple
(params) { var request = this.searchProjectPersonsMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
public newEmployeeCm(): IEmployeeCm {
    return <IEmployeeCm>{};
}
public newEmployeeVm(): IEmployeeVm {
    return <IEmployeeVm>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
public newProjectPersonVm(): IProjectPersonVm {
    return <IProjectPersonVm>{};
}
public newAssignedProjectVm(): IAssignedProjectVm {
    return <IAssignedProjectVm>{};
}
public newFeatureClaimVm(): IFeatureClaimVm {
    return <IFeatureClaimVm>{};
}
}
    export interface ITimeValidationResource {
        signRequest ( data: ISignParam) : DataRequest<any>;
        sign( data: ISignParam) : angular.IPromise<DataResponse<any>>;
        canSignRequest ( data: ISignParam) : DataRequest<boolean>;
        canSign( data: ISignParam) : angular.IPromise<DataResponse<boolean>>;
        newSignParam(): ISignParam;
    };
    export class TimeValidationResource implements ITimeValidationResource {
        constructor(private $requestSender) {}
                signRequest(data) {         var url = this.$requestSender.getUrl('$proxy') + "/TimeValidation/Sign";
        var dataRequest = new DataRequest<any>("POST", url, data, "TimeValidation", "any", true);
        return dataRequest;
    }
            sign
(data) {     var request = this.        signRequest(data);
    return this.$requestSender.requestValue(request);
}
canSignRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeValidation/CanSign";
var dataRequest = new DataRequest<boolean>("POST", url, data, "TimeValidation", "boolean", true);
return dataRequest;
}
canSign
(data) { var request = this.canSignRequest(data);
return this.$requestSender.requestValue(request);
}
public newSignParam(): ISignParam {
    return <ISignParam>{};
}
}
    export interface ITimeStampResource {
        submitStampRequest ( data: ICreateStampVm) : DataRequest<any>;
        submitStamp( data: ICreateStampVm) : angular.IPromise<DataResponse<any>>;
        submitStampsRequest ( data: ICreateStampVm[]) : DataRequest<any>;
        submitStamps( data: ICreateStampVm[]) : angular.IPromise<DataResponse<any>>;
        newCreateStampVm(): ICreateStampVm;
    };
    export class TimeStampResource implements ITimeStampResource {
        constructor(private $requestSender) {}
                submitStampRequest(data) {         var url = this.$requestSender.getUrl('$proxy') + "/TimeStamp/SubmitStamp";
        var dataRequest = new DataRequest<any>("POST", url, data, "TimeStamp", "any", true);
        return dataRequest;
    }
            submitStamp
(data) {     var request = this.        submitStampRequest(data);
    return this.$requestSender.requestValue(request);
}
submitStampsRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeStamp/SubmitStamps";
var dataRequest = new DataRequest<any>("POST", url, data, "TimeStamp", "any", true);
return dataRequest;
}
submitStamps
(data) { var request = this.submitStampsRequest(data);
return this.$requestSender.requestValue(request);
}
public newCreateStampVm(): ICreateStampVm {
    return <ICreateStampVm>{};
}
}
    export interface AccountSearchEnumerableParams {
        search : string;
        skip : number;
        take : number;
        userType? : EAppUserType;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface AccountGetInactiveUsersEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface AccountResetPasswordParams {
        userId : string;
    }
    export interface AccountGetManageInfoParams {
        returnUrl : string;
        generateState? : boolean;
    }
    export interface AccountGetExternalLoginParams {
        provider : string;
        error? : string;
    }
    export interface AccountGetExternalLoginsEnumerableParams {
        returnUrl : string;
        generateState? : boolean;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IAccountResource {
        getAppUserRequest ( ) : DataRequest<IAppUser>;
        getAppUser( ) : angular.IPromise<DataResponse<IAppUser>>;
        getMobileUserRequest ( ) : DataRequest<IMobileUser>;
        getMobileUser( ) : angular.IPromise<DataResponse<IMobileUser>>;
        loginRequest ( data: ILoginViewModel) : DataRequest<any>;
        login( data: ILoginViewModel) : angular.IPromise<DataResponse<any>>;
        mobileLoginRequest ( data: ILoginViewModel) : DataRequest<IMobileUser>;
        mobileLogin( data: ILoginViewModel) : angular.IPromise<DataResponse<IMobileUser>>;
        searchMultipleRequest (params: AccountSearchEnumerableParams ) : DataRequest<IUserVm[]>;
        searchMultiple(params: AccountSearchEnumerableParams ) : angular.IPromise<DataResponse<IUserVm[]>>;
        getInactiveUsersMultipleRequest (params: AccountGetInactiveUsersEnumerableParams ) : DataRequest<IUserVm[]>;
        getInactiveUsersMultiple(params: AccountGetInactiveUsersEnumerableParams ) : angular.IPromise<DataResponse<IUserVm[]>>;
        createUserRequest ( data: IUserVm) : DataRequest<any>;
        createUser( data: IUserVm) : angular.IPromise<DataResponse<any>>;
        editUserRequest ( data: IUserVm) : DataRequest<any>;
        editUser( data: IUserVm) : angular.IPromise<DataResponse<any>>;
        editOwnPasswordRequest ( data: IUserVm) : DataRequest<any>;
        editOwnPassword( data: IUserVm) : angular.IPromise<DataResponse<any>>;
        resetPasswordRequest (params: AccountResetPasswordParams ) : DataRequest<any>;
        resetPassword(params: AccountResetPasswordParams ) : angular.IPromise<DataResponse<any>>;
        deleteRequest ( data: IUserVm) : DataRequest<any>;
        delete( data: IUserVm) : angular.IPromise<DataResponse<any>>;
        pingRequest ( ) : DataRequest<any>;
        ping( ) : angular.IPromise<DataResponse<any>>;
        logoutRequest ( ) : DataRequest<any>;
        logout( ) : angular.IPromise<DataResponse<any>>;
        getUserInfoRequest ( ) : DataRequest<IUserInfoViewModel>;
        getUserInfo( ) : angular.IPromise<DataResponse<IUserInfoViewModel>>;
        getManageInfoRequest (params: AccountGetManageInfoParams ) : DataRequest<IManageInfoViewModel>;
        getManageInfo(params: AccountGetManageInfoParams ) : angular.IPromise<DataResponse<IManageInfoViewModel>>;
        changePasswordRequest ( data: IChangePasswordBindingModel) : DataRequest<any>;
        changePassword( data: IChangePasswordBindingModel) : angular.IPromise<DataResponse<any>>;
        setPasswordRequest ( data: ISetPasswordBindingModel) : DataRequest<any>;
        setPassword( data: ISetPasswordBindingModel) : angular.IPromise<DataResponse<any>>;
        addExternalLoginRequest ( data: IAddExternalLoginBindingModel) : DataRequest<any>;
        addExternalLogin( data: IAddExternalLoginBindingModel) : angular.IPromise<DataResponse<any>>;
        removeLoginRequest ( data: IRemoveLoginBindingModel) : DataRequest<any>;
        removeLogin( data: IRemoveLoginBindingModel) : angular.IPromise<DataResponse<any>>;
        getExternalLoginRequest (params: AccountGetExternalLoginParams ) : DataRequest<any>;
        getExternalLogin(params: AccountGetExternalLoginParams ) : angular.IPromise<DataResponse<any>>;
        getExternalLoginsMultipleRequest (params: AccountGetExternalLoginsEnumerableParams ) : DataRequest<IExternalLoginViewModel[]>;
        getExternalLoginsMultiple(params: AccountGetExternalLoginsEnumerableParams ) : angular.IPromise<DataResponse<IExternalLoginViewModel[]>>;
        registerRequest ( data: IRegisterVm) : DataRequest<any>;
        register( data: IRegisterVm) : angular.IPromise<DataResponse<any>>;
        registerExternalRequest ( data: IRegisterExternalBindingModel) : DataRequest<any>;
        registerExternal( data: IRegisterExternalBindingModel) : angular.IPromise<DataResponse<any>>;
        newAppUser(): IAppUser;
        newMobileUser(): IMobileUser;
        newUserVm(): IUserVm;
        newUserInfoViewModel(): IUserInfoViewModel;
        newManageInfoViewModel(): IManageInfoViewModel;
        newExternalLoginViewModel(): IExternalLoginViewModel;
        newLoginViewModel(): ILoginViewModel;
        newChangePasswordBindingModel(): IChangePasswordBindingModel;
        newSetPasswordBindingModel(): ISetPasswordBindingModel;
        newAddExternalLoginBindingModel(): IAddExternalLoginBindingModel;
        newRemoveLoginBindingModel(): IRemoveLoginBindingModel;
        newRegisterVm(): IRegisterVm;
        newRegisterExternalBindingModel(): IRegisterExternalBindingModel;
        newEmployeeCm(): IEmployeeCm;
        newLocationVm(): ILocationVm;
        newAppConfig(): IAppConfig;
        newEmployeeVm(): IEmployeeVm;
    };
    export class AccountResource implements IAccountResource {
        constructor(private $requestSender) {}
                getAppUserRequest() {         var url = this.$requestSender.getUrl('$proxy') + "/Account/GetAppUser";
        var dataRequest = new DataRequest<IAppUser>("GET", url, {}, "Account", "IAppUser", false);
        return dataRequest;
    }
            getAppUser
() {     var request = this.        getAppUserRequest();
    return this.$requestSender.requestValue(request);
}
getMobileUserRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Account/GetMobileUser";
var dataRequest = new DataRequest<IMobileUser>("GET", url, {}, "Account", "IMobileUser", false);
return dataRequest;
}
getMobileUser
() { var request = this.getMobileUserRequest();
return this.$requestSender.requestValue(request);
}
loginRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/Login";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
login
(data) { var request = this.loginRequest(data);
return this.$requestSender.requestValue(request);
}
mobileLoginRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/MobileLogin";
var dataRequest = new DataRequest<IMobileUser>("POST", url, data, "Account", "IMobileUser", true);
return dataRequest;
}
mobileLogin
(data) { var request = this.mobileLoginRequest(data);
return this.$requestSender.requestValue(request);
}
searchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Account/Search";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.skip)) {
    url = TriarcData.appendUrlParameter(url, "skip", encodeURIComponent(params.skip));
}
if(angular.isDefined(params.take)) {
    url = TriarcData.appendUrlParameter(url, "take", encodeURIComponent(params.take));
}
if(angular.isDefined(params.userType)) {
    url = TriarcData.appendUrlParameter(url, "userType", encodeURIComponent(params.userType));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IUserVm[]>("GET", url, {}, "Account", "IUserVm[]", false);
return dataRequest;
}
searchMultiple
(params) { var request = this.searchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
getInactiveUsersMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Account/GetInactiveUsers";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IUserVm[]>("GET", url, {}, "Account", "IUserVm[]", false);
return dataRequest;
}
getInactiveUsersMultiple
(params) { var request = this.getInactiveUsersMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
createUserRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/CreateUser";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
createUser
(data) { var request = this.createUserRequest(data);
return this.$requestSender.requestValue(request);
}
editUserRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/EditUser";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
editUser
(data) { var request = this.editUserRequest(data);
return this.$requestSender.requestValue(request);
}
editOwnPasswordRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/EditOwnPassword";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
editOwnPassword
(data) { var request = this.editOwnPasswordRequest(data);
return this.$requestSender.requestValue(request);
}
resetPasswordRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Account/ResetPassword";
if(angular.isDefined(params.userId)) {
    url = TriarcData.appendUrlParameter(url, "userId", encodeURIComponent(params.userId));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Account", "any", false);
return dataRequest;
}
resetPassword
(params) { var request = this.resetPasswordRequest(params);
return this.$requestSender.requestValue(request);
}
deleteRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/Delete";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
delete
(data) { var request = this.deleteRequest(data);
return this.$requestSender.requestValue(request);
}
pingRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Account/Ping";
var dataRequest = new DataRequest<any>("GET", url, {}, "Account", "any", false);
return dataRequest;
}
ping
() { var request = this.pingRequest();
return this.$requestSender.requestValue(request);
}
logoutRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Account/Logout";
var dataRequest = new DataRequest<any>("POST", url, {}, "Account", "any", false);
return dataRequest;
}
logout
() { var request = this.logoutRequest();
return this.$requestSender.requestValue(request);
}
getUserInfoRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Account/GetUserInfo";
var dataRequest = new DataRequest<IUserInfoViewModel>("GET", url, {}, "Account", "IUserInfoViewModel", false);
return dataRequest;
}
getUserInfo
() { var request = this.getUserInfoRequest();
return this.$requestSender.requestValue(request);
}
getManageInfoRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Account/GetManageInfo";
if(angular.isDefined(params.returnUrl)) {
    url = TriarcData.appendUrlParameter(url, "returnUrl", encodeURIComponent(params.returnUrl));
}
if(angular.isDefined(params.generateState)) {
    url = TriarcData.appendUrlParameter(url, "generateState", encodeURIComponent(params.generateState));
}
var dataRequest = new DataRequest<IManageInfoViewModel>("GET", url, {}, "Account", "IManageInfoViewModel", false);
return dataRequest;
}
getManageInfo
(params) { var request = this.getManageInfoRequest(params);
return this.$requestSender.requestValue(request);
}
changePasswordRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/ChangePassword";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
changePassword
(data) { var request = this.changePasswordRequest(data);
return this.$requestSender.requestValue(request);
}
setPasswordRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/SetPassword";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
setPassword
(data) { var request = this.setPasswordRequest(data);
return this.$requestSender.requestValue(request);
}
addExternalLoginRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/AddExternalLogin";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
addExternalLogin
(data) { var request = this.addExternalLoginRequest(data);
return this.$requestSender.requestValue(request);
}
removeLoginRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/RemoveLogin";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
removeLogin
(data) { var request = this.removeLoginRequest(data);
return this.$requestSender.requestValue(request);
}
getExternalLoginRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Account/GetExternalLogin";
if(angular.isDefined(params.provider)) {
    url = TriarcData.appendUrlParameter(url, "provider", encodeURIComponent(params.provider));
}
if(angular.isDefined(params.error)) {
    url = TriarcData.appendUrlParameter(url, "error", encodeURIComponent(params.error));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Account", "any", false);
return dataRequest;
}
getExternalLogin
(params) { var request = this.getExternalLoginRequest(params);
return this.$requestSender.requestValue(request);
}
getExternalLoginsMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Account/GetExternalLogins";
if(angular.isDefined(params.returnUrl)) {
    url = TriarcData.appendUrlParameter(url, "returnUrl", encodeURIComponent(params.returnUrl));
}
if(angular.isDefined(params.generateState)) {
    url = TriarcData.appendUrlParameter(url, "generateState", encodeURIComponent(params.generateState));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IExternalLoginViewModel[]>("GET", url, {}, "Account", "IExternalLoginViewModel[]", false);
return dataRequest;
}
getExternalLoginsMultiple
(params) { var request = this.getExternalLoginsMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
registerRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/Register";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
register
(data) { var request = this.registerRequest(data);
return this.$requestSender.requestValue(request);
}
registerExternalRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Account/RegisterExternal";
var dataRequest = new DataRequest<any>("POST", url, data, "Account", "any", true);
return dataRequest;
}
registerExternal
(data) { var request = this.registerExternalRequest(data);
return this.$requestSender.requestValue(request);
}
public newAppUser(): IAppUser {
    return <IAppUser>{};
}
public newMobileUser(): IMobileUser {
    return <IMobileUser>{};
}
public newUserVm(): IUserVm {
    return <IUserVm>{};
}
public newUserInfoViewModel(): IUserInfoViewModel {
    return <IUserInfoViewModel>{};
}
public newManageInfoViewModel(): IManageInfoViewModel {
    return <IManageInfoViewModel>{};
}
public newExternalLoginViewModel(): IExternalLoginViewModel {
    return <IExternalLoginViewModel>{};
}
public newLoginViewModel(): ILoginViewModel {
    return <ILoginViewModel>{};
}
public newChangePasswordBindingModel(): IChangePasswordBindingModel {
    return <IChangePasswordBindingModel>{};
}
public newSetPasswordBindingModel(): ISetPasswordBindingModel {
    return <ISetPasswordBindingModel>{};
}
public newAddExternalLoginBindingModel(): IAddExternalLoginBindingModel {
    return <IAddExternalLoginBindingModel>{};
}
public newRemoveLoginBindingModel(): IRemoveLoginBindingModel {
    return <IRemoveLoginBindingModel>{};
}
public newRegisterVm(): IRegisterVm {
    return <IRegisterVm>{};
}
public newRegisterExternalBindingModel(): IRegisterExternalBindingModel {
    return <IRegisterExternalBindingModel>{};
}
public newEmployeeCm(): IEmployeeCm {
    return <IEmployeeCm>{};
}
public newLocationVm(): ILocationVm {
    return <ILocationVm>{};
}
public newAppConfig(): IAppConfig {
    return <IAppConfig>{};
}
public newEmployeeVm(): IEmployeeVm {
    return <IEmployeeVm>{};
}
}
    export interface IAdminResource {
        getServerVersionRequest ( ) : DataRequest<string>;
        getServerVersion( ) : angular.IPromise<DataResponse<string>>;
        getInjectedConfigRequest ( ) : DataRequest<ITimeRecorderConfiguration>;
        getInjectedConfig( ) : angular.IPromise<DataResponse<ITimeRecorderConfiguration>>;
        getReparsedConfigRequest ( ) : DataRequest<ITimeRecorderConfiguration>;
        getReparsedConfig( ) : angular.IPromise<DataResponse<ITimeRecorderConfiguration>>;
        migrateUsersRequest ( ) : DataRequest<any>;
        migrateUsers( ) : angular.IPromise<DataResponse<any>>;
        requeueTimeBookingsRequest ( data: IRequeBookingsModel) : DataRequest<any>;
        requeueTimeBookings( data: IRequeBookingsModel) : angular.IPromise<DataResponse<any>>;
        requeueExpensesRequest ( ) : DataRequest<any>;
        requeueExpenses( ) : angular.IPromise<DataResponse<any>>;
        newKeyVaulePair(): IKeyVaulePair;
        newTimeRecorderConfiguration(): ITimeRecorderConfiguration;
        newRequeBookingsModel(): IRequeBookingsModel;
    };
    export class AdminResource implements IAdminResource {
        constructor(private $requestSender) {}
                getServerVersionRequest() {         var url = this.$requestSender.getUrl('$proxy') + "/Admin/GetServerVersion";
        var dataRequest = new DataRequest<string>("GET", url, {}, "Admin", "string", false);
        return dataRequest;
    }
            getServerVersion
() {     var request = this.        getServerVersionRequest();
    return this.$requestSender.requestValue(request);
}
getInjectedConfigRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Admin/GetInjectedConfig";
var dataRequest = new DataRequest<ITimeRecorderConfiguration>("GET", url, {}, "Admin", "ITimeRecorderConfiguration", false);
return dataRequest;
}
getInjectedConfig
() { var request = this.getInjectedConfigRequest();
return this.$requestSender.requestValue(request);
}
getReparsedConfigRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Admin/GetReparsedConfig";
var dataRequest = new DataRequest<ITimeRecorderConfiguration>("GET", url, {}, "Admin", "ITimeRecorderConfiguration", false);
return dataRequest;
}
getReparsedConfig
() { var request = this.getReparsedConfigRequest();
return this.$requestSender.requestValue(request);
}
migrateUsersRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Admin/MigrateUsers";
var dataRequest = new DataRequest<any>("GET", url, {}, "Admin", "any", false);
return dataRequest;
}
migrateUsers
() { var request = this.migrateUsersRequest();
return this.$requestSender.requestValue(request);
}
requeueTimeBookingsRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Admin/RequeueTimeBookings";
var dataRequest = new DataRequest<any>("POST", url, data, "Admin", "any", true);
return dataRequest;
}
requeueTimeBookings
(data) { var request = this.requeueTimeBookingsRequest(data);
return this.$requestSender.requestValue(request);
}
requeueExpensesRequest() { var url = this.$requestSender.getUrl('$proxy') + "/Admin/RequeueExpenses";
var dataRequest = new DataRequest<any>("GET", url, {}, "Admin", "any", false);
return dataRequest;
}
requeueExpenses
() { var request = this.requeueExpensesRequest();
return this.$requestSender.requestValue(request);
}
public newKeyVaulePair(): IKeyVaulePair {
    return <IKeyVaulePair>{};
}
public newTimeRecorderConfiguration(): ITimeRecorderConfiguration {
    return <ITimeRecorderConfiguration>{};
}
public newRequeBookingsModel(): IRequeBookingsModel {
    return <IRequeBookingsModel>{};
}
}
    export interface RoleGetConfigsEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface RoleSearchEnumerableParams {
        search : string;
        skip : number;
        take : number;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IRoleResource {
        getConfigsMultipleRequest (params: RoleGetConfigsEnumerableParams ) : DataRequest<IProfileConfigVm[]>;
        getConfigsMultiple(params: RoleGetConfigsEnumerableParams ) : angular.IPromise<DataResponse<IProfileConfigVm[]>>;
        searchMultipleRequest (params: RoleSearchEnumerableParams ) : DataRequest<IProfileConfigVm[]>;
        searchMultiple(params: RoleSearchEnumerableParams ) : angular.IPromise<DataResponse<IProfileConfigVm[]>>;
        deleteRequest ( data: IProfileConfigVm) : DataRequest<any>;
        delete( data: IProfileConfigVm) : angular.IPromise<DataResponse<any>>;
        saveRequest ( data: IProfileConfigVm) : DataRequest<any>;
        save( data: IProfileConfigVm) : angular.IPromise<DataResponse<any>>;
        newProfileConfigVm(): IProfileConfigVm;
    };
    export class RoleResource implements IRoleResource {
        constructor(private $requestSender) {}
                getConfigsMultipleRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Role/GetConfigs";
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<IProfileConfigVm[]>("GET", url, {}, "Role", "IProfileConfigVm[]", false);
        return dataRequest;
    }
            getConfigsMultiple
(params) {     var request = this.        getConfigsMultipleRequest(params);
    return this.$requestSender.requestValue(request);
}
searchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Role/Search";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.skip)) {
    url = TriarcData.appendUrlParameter(url, "skip", encodeURIComponent(params.skip));
}
if(angular.isDefined(params.take)) {
    url = TriarcData.appendUrlParameter(url, "take", encodeURIComponent(params.take));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IProfileConfigVm[]>("POST", url, {}, "Role", "IProfileConfigVm[]", false);
return dataRequest;
}
searchMultiple
(params) { var request = this.searchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
deleteRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Role/Delete";
var dataRequest = new DataRequest<any>("POST", url, data, "Role", "any", true);
return dataRequest;
}
delete
(data) { var request = this.deleteRequest(data);
return this.$requestSender.requestValue(request);
}
saveRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Role/Save";
var dataRequest = new DataRequest<any>("POST", url, data, "Role", "any", true);
return dataRequest;
}
save
(data) { var request = this.saveRequest(data);
return this.$requestSender.requestValue(request);
}
public newProfileConfigVm(): IProfileConfigVm {
    return <IProfileConfigVm>{};
}
}
    export interface TimeSheetGetTimesheetEmployeesEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface ITimeSheetResource {
        getTimesheetRequest ( data: ITimesheetSearchCriteria) : DataRequest<ITimesheetCm>;
        getTimesheet( data: ITimesheetSearchCriteria) : angular.IPromise<DataResponse<ITimesheetCm>>;
        getTimesheetEmployeesMultipleRequest (params: TimeSheetGetTimesheetEmployeesEnumerableParams , data: ITimesheetSearchCriteria) : DataRequest<ITypeAheadModel[]>;
        getTimesheetEmployeesMultiple(params: TimeSheetGetTimesheetEmployeesEnumerableParams , data: ITimesheetSearchCriteria) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        getTimesheetDayForRequest ( data: ITimesheetSearchCriteria) : DataRequest<ITimeSheetDayCm>;
        getTimesheetDayFor( data: ITimesheetSearchCriteria) : angular.IPromise<DataResponse<ITimeSheetDayCm>>;
        newTimesheetCm(): ITimesheetCm;
        newTypeAheadModel(): ITypeAheadModel;
        newTimeSheetDayCm(): ITimeSheetDayCm;
        newTimesheetSearchCriteria(): ITimesheetSearchCriteria;
        newAddressVm(): IAddressVm;
        newRulesPerDay(): IRulesPerDay;
    };
    export class TimeSheetResource implements ITimeSheetResource {
        constructor(private $requestSender) {}
                getTimesheetRequest(data) {         var url = this.$requestSender.getUrl('$proxy') + "/TimeSheet/GetTimesheet";
        var dataRequest = new DataRequest<ITimesheetCm>("POST", url, data, "TimeSheet", "ITimesheetCm", true);
        return dataRequest;
    }
            getTimesheet
(data) {     var request = this.        getTimesheetRequest(data);
    return this.$requestSender.requestValue(request);
}
getTimesheetEmployeesMultipleRequest(params,data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeSheet/GetTimesheetEmployees";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITypeAheadModel[]>("POST", url, data, "TimeSheet", "ITypeAheadModel[]", true);
return dataRequest;
}
getTimesheetEmployeesMultiple
(params,data) { var request = this.getTimesheetEmployeesMultipleRequest(params,data);
return this.$requestSender.requestValue(request);
}
getTimesheetDayForRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeSheet/GetTimesheetDayFor";
var dataRequest = new DataRequest<ITimeSheetDayCm>("POST", url, data, "TimeSheet", "ITimeSheetDayCm", true);
return dataRequest;
}
getTimesheetDayFor
(data) { var request = this.getTimesheetDayForRequest(data);
return this.$requestSender.requestValue(request);
}
public newTimesheetCm(): ITimesheetCm {
    return <ITimesheetCm>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
public newTimeSheetDayCm(): ITimeSheetDayCm {
    return <ITimeSheetDayCm>{};
}
public newTimesheetSearchCriteria(): ITimesheetSearchCriteria {
    return <ITimesheetSearchCriteria>{};
}
public newAddressVm(): IAddressVm {
    return <IAddressVm>{};
}
public newRulesPerDay(): IRulesPerDay {
    return <IRulesPerDay>{};
}
}
    export interface ChangeTrackingGetChangesEnumerableParams {
        entryId : string;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IChangeTrackingResource {
        getChangesMultipleRequest (params: ChangeTrackingGetChangesEnumerableParams ) : DataRequest<IChangeSetVm[]>;
        getChangesMultiple(params: ChangeTrackingGetChangesEnumerableParams ) : angular.IPromise<DataResponse<IChangeSetVm[]>>;
        newChangeSetVm(): IChangeSetVm;
    };
    export class ChangeTrackingResource implements IChangeTrackingResource {
        constructor(private $requestSender) {}
                getChangesMultipleRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/ChangeTracking/GetChanges";
        if(angular.isDefined(params.entryId)) {
            url = TriarcData.appendUrlParameter(url, "entryId", encodeURIComponent(params.entryId));
        }
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<IChangeSetVm[]>("GET", url, {}, "ChangeTracking", "IChangeSetVm[]", false);
        return dataRequest;
    }
            getChangesMultiple
(params) {     var request = this.        getChangesMultipleRequest(params);
    return this.$requestSender.requestValue(request);
}
public newChangeSetVm(): IChangeSetVm {
    return <IChangeSetVm>{};
}
}
    export interface IConfigResource {
        getRequest ( ) : DataRequest<IConfigVm>;
        get( ) : angular.IPromise<DataResponse<IConfigVm>>;
        putRequest ( data: ISaveConfigVm) : DataRequest<any>;
        put( data: ISaveConfigVm) : angular.IPromise<DataResponse<any>>;
        newConfigVm(): IConfigVm;
        newSaveConfigVm(): ISaveConfigVm;
    };
    export class ConfigResource implements IConfigResource {
        constructor(private $requestSender) {}
                getRequest() {         var url = this.$requestSender.getUrl('$proxy') + "/Config/Get";
        var dataRequest = new DataRequest<IConfigVm>("GET", url, {}, "Config", "IConfigVm", false);
        return dataRequest;
    }
            get
() {     var request = this.        getRequest();
    return this.$requestSender.requestValue(request);
}
putRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Config/Put";
var dataRequest = new DataRequest<any>("POST", url, data, "Config", "any", true);
return dataRequest;
}
put
(data) { var request = this.putRequest(data);
return this.$requestSender.requestValue(request);
}
public newConfigVm(): IConfigVm {
    return <IConfigVm>{};
}
public newSaveConfigVm(): ISaveConfigVm {
    return <ISaveConfigVm>{};
}
}
    export interface ImportImportEmployeesParams {
        amount? : number;
    }
    export interface ImportImportEmployeeParams {
        id : number;
    }
    export interface ImportImportProjectBookingsParams {
        amount? : number;
    }
    export interface ImportImportProjectsParams {
        amount? : number;
    }
    export interface ImportImportProjectParams {
        id : number;
    }
    export interface ImportImportSvmParams {
        amount? : number;
    }
    export interface IImportResource {
        importEmployeesRequest (params: ImportImportEmployeesParams ) : DataRequest<any>;
        importEmployees(params: ImportImportEmployeesParams ) : angular.IPromise<DataResponse<any>>;
        importEmployeeRequest (params: ImportImportEmployeeParams ) : DataRequest<any>;
        importEmployee(params: ImportImportEmployeeParams ) : angular.IPromise<DataResponse<any>>;
        importProjectBookingsRequest (params: ImportImportProjectBookingsParams ) : DataRequest<any>;
        importProjectBookings(params: ImportImportProjectBookingsParams ) : angular.IPromise<DataResponse<any>>;
        importProjectsRequest (params: ImportImportProjectsParams ) : DataRequest<any>;
        importProjects(params: ImportImportProjectsParams ) : angular.IPromise<DataResponse<any>>;
        importProjectRequest (params: ImportImportProjectParams ) : DataRequest<any>;
        importProject(params: ImportImportProjectParams ) : angular.IPromise<DataResponse<any>>;
        importSvmRequest (params: ImportImportSvmParams ) : DataRequest<any>;
        importSvm(params: ImportImportSvmParams ) : angular.IPromise<DataResponse<any>>;
    };
    export class ImportResource implements IImportResource {
        constructor(private $requestSender) {}
                importEmployeesRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Import/ImportEmployees";
        if(angular.isDefined(params.amount)) {
            url = TriarcData.appendUrlParameter(url, "amount", encodeURIComponent(params.amount));
        }
        var dataRequest = new DataRequest<any>("GET", url, {}, "Import", "any", false);
        return dataRequest;
    }
            importEmployees
(params) {     var request = this.        importEmployeesRequest(params);
    return this.$requestSender.requestValue(request);
}
importEmployeeRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Import/ImportEmployee";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Import", "any", false);
return dataRequest;
}
importEmployee
(params) { var request = this.importEmployeeRequest(params);
return this.$requestSender.requestValue(request);
}
importProjectBookingsRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Import/ImportProjectBookings";
if(angular.isDefined(params.amount)) {
    url = TriarcData.appendUrlParameter(url, "amount", encodeURIComponent(params.amount));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Import", "any", false);
return dataRequest;
}
importProjectBookings
(params) { var request = this.importProjectBookingsRequest(params);
return this.$requestSender.requestValue(request);
}
importProjectsRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Import/ImportProjects";
if(angular.isDefined(params.amount)) {
    url = TriarcData.appendUrlParameter(url, "amount", encodeURIComponent(params.amount));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Import", "any", false);
return dataRequest;
}
importProjects
(params) { var request = this.importProjectsRequest(params);
return this.$requestSender.requestValue(request);
}
importProjectRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Import/ImportProject";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Import", "any", false);
return dataRequest;
}
importProject
(params) { var request = this.importProjectRequest(params);
return this.$requestSender.requestValue(request);
}
importSvmRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Import/ImportSvm";
if(angular.isDefined(params.amount)) {
    url = TriarcData.appendUrlParameter(url, "amount", encodeURIComponent(params.amount));
}
var dataRequest = new DataRequest<any>("GET", url, {}, "Import", "any", false);
return dataRequest;
}
importSvm
(params) { var request = this.importSvmRequest(params);
return this.$requestSender.requestValue(request);
}
}
    export interface ClaimGetClaimsEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IClaimResource {
        getClaimsMultipleRequest (params: ClaimGetClaimsEnumerableParams ) : DataRequest<IFeatureClaimVm[]>;
        getClaimsMultiple(params: ClaimGetClaimsEnumerableParams ) : angular.IPromise<DataResponse<IFeatureClaimVm[]>>;
        newFeatureClaimVm(): IFeatureClaimVm;
    };
    export class ClaimResource implements IClaimResource {
        constructor(private $requestSender) {}
                getClaimsMultipleRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Claim/GetClaims";
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<IFeatureClaimVm[]>("GET", url, {}, "Claim", "IFeatureClaimVm[]", false);
        return dataRequest;
    }
            getClaimsMultiple
(params) {     var request = this.        getClaimsMultipleRequest(params);
    return this.$requestSender.requestValue(request);
}
public newFeatureClaimVm(): IFeatureClaimVm {
    return <IFeatureClaimVm>{};
}
}
    export interface LicenceSetLicenceKeyParams {
        key : string;
    }
    export interface ILicenceResource {
        getStatusRequest ( ) : DataRequest<ILicenceStatusVm>;
        getStatus( ) : angular.IPromise<DataResponse<ILicenceStatusVm>>;
        setLicenceKeyRequest (params: LicenceSetLicenceKeyParams ) : DataRequest<ILicenceStatusVm>;
        setLicenceKey(params: LicenceSetLicenceKeyParams ) : angular.IPromise<DataResponse<ILicenceStatusVm>>;
        newLicenceStatusVm(): ILicenceStatusVm;
    };
    export class LicenceResource implements ILicenceResource {
        constructor(private $requestSender) {}
                getStatusRequest() {         var url = this.$requestSender.getUrl('$proxy') + "/Licence/GetStatus";
        var dataRequest = new DataRequest<ILicenceStatusVm>("GET", url, {}, "Licence", "ILicenceStatusVm", false);
        return dataRequest;
    }
            getStatus
() {     var request = this.        getStatusRequest();
    return this.$requestSender.requestValue(request);
}
setLicenceKeyRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Licence/SetLicenceKey";
if(angular.isDefined(params.key)) {
    url = TriarcData.appendUrlParameter(url, "key", encodeURIComponent(params.key));
}
var dataRequest = new DataRequest<ILicenceStatusVm>("POST", url, {}, "Licence", "ILicenceStatusVm", false);
return dataRequest;
}
setLicenceKey
(params) { var request = this.setLicenceKeyRequest(params);
return this.$requestSender.requestValue(request);
}
public newLicenceStatusVm(): ILicenceStatusVm {
    return <ILicenceStatusVm>{};
}
}
    export interface TimeRulesConfigGetConfigsEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface TimeRulesConfigSearchEnumerableParams {
        search : string;
        skip : number;
        take : number;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface ITimeRulesConfigResource {
        getConfigsMultipleRequest (params: TimeRulesConfigGetConfigsEnumerableParams ) : DataRequest<ITimeRulesConfigVm[]>;
        getConfigsMultiple(params: TimeRulesConfigGetConfigsEnumerableParams ) : angular.IPromise<DataResponse<ITimeRulesConfigVm[]>>;
        searchMultipleRequest (params: TimeRulesConfigSearchEnumerableParams ) : DataRequest<ITimeRulesConfigVm[]>;
        searchMultiple(params: TimeRulesConfigSearchEnumerableParams ) : angular.IPromise<DataResponse<ITimeRulesConfigVm[]>>;
        deleteRequest ( data: ITimeRulesConfigVm) : DataRequest<any>;
        delete( data: ITimeRulesConfigVm) : angular.IPromise<DataResponse<any>>;
        saveRequest ( data: ITimeRulesConfigVm) : DataRequest<any>;
        save( data: ITimeRulesConfigVm) : angular.IPromise<DataResponse<any>>;
        newTimeRulesConfigVm(): ITimeRulesConfigVm;
        newTypeAheadModel(): ITypeAheadModel;
    };
    export class TimeRulesConfigResource implements ITimeRulesConfigResource {
        constructor(private $requestSender) {}
                getConfigsMultipleRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/TimeRulesConfig/GetConfigs";
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<ITimeRulesConfigVm[]>("GET", url, {}, "TimeRulesConfig", "ITimeRulesConfigVm[]", false);
        return dataRequest;
    }
            getConfigsMultiple
(params) {     var request = this.        getConfigsMultipleRequest(params);
    return this.$requestSender.requestValue(request);
}
searchMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/TimeRulesConfig/Search";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.skip)) {
    url = TriarcData.appendUrlParameter(url, "skip", encodeURIComponent(params.skip));
}
if(angular.isDefined(params.take)) {
    url = TriarcData.appendUrlParameter(url, "take", encodeURIComponent(params.take));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITimeRulesConfigVm[]>("POST", url, {}, "TimeRulesConfig", "ITimeRulesConfigVm[]", false);
return dataRequest;
}
searchMultiple
(params) { var request = this.searchMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
deleteRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeRulesConfig/Delete";
var dataRequest = new DataRequest<any>("POST", url, data, "TimeRulesConfig", "any", true);
return dataRequest;
}
delete
(data) { var request = this.deleteRequest(data);
return this.$requestSender.requestValue(request);
}
saveRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeRulesConfig/Save";
var dataRequest = new DataRequest<any>("POST", url, data, "TimeRulesConfig", "any", true);
return dataRequest;
}
save
(data) { var request = this.saveRequest(data);
return this.$requestSender.requestValue(request);
}
public newTimeRulesConfigVm(): ITimeRulesConfigVm {
    return <ITimeRulesConfigVm>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
}
    export interface TimeBookingSearchBookingsEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface TimeBookingBrowseEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface TimeBookingGetTimebookingDetailParams {
        id : string;
    }
    export interface TimeBookingDeleteParams {
        id : string;
    }
    export interface ITimeBookingResource {
        searchBookingsMultipleRequest (params: TimeBookingSearchBookingsEnumerableParams , data: ITimeBookingSearchCirteria) : DataRequest<ITimeBookingVm[]>;
        searchBookingsMultiple(params: TimeBookingSearchBookingsEnumerableParams , data: ITimeBookingSearchCirteria) : angular.IPromise<DataResponse<ITimeBookingVm[]>>;
        browseMultipleRequest (params: TimeBookingBrowseEnumerableParams , data: IBrowseModel) : DataRequest<ITimeBookingVm[]>;
        browseMultiple(params: TimeBookingBrowseEnumerableParams , data: IBrowseModel) : angular.IPromise<DataResponse<ITimeBookingVm[]>>;
        getTimebookingDetailRequest (params: TimeBookingGetTimebookingDetailParams ) : DataRequest<ITimeBookingDetailVm>;
        getTimebookingDetail(params: TimeBookingGetTimebookingDetailParams ) : angular.IPromise<DataResponse<ITimeBookingDetailVm>>;
        deleteRequest (params: TimeBookingDeleteParams ) : DataRequest<any>;
        delete(params: TimeBookingDeleteParams ) : angular.IPromise<DataResponse<any>>;
        saveBookingRequest ( data: ITimeBookingDetailVm) : DataRequest<boolean>;
        saveBooking( data: ITimeBookingDetailVm) : angular.IPromise<DataResponse<boolean>>;
        reImportBookingsRequest ( data: IBookingImportConditions) : DataRequest<any>;
        reImportBookings( data: IBookingImportConditions) : angular.IPromise<DataResponse<any>>;
        triggerForceReloadRequest ( ) : DataRequest<number>;
        triggerForceReload( ) : angular.IPromise<DataResponse<number>>;
        newTimeBookingVm(): ITimeBookingVm;
        newTimeBookingDetailVm(): ITimeBookingDetailVm;
        newTimeBookingSearchCirteria(): ITimeBookingSearchCirteria;
        newBrowseModel(): IBrowseModel;
        newBookingImportConditions(): IBookingImportConditions;
        newTypeAheadModel(): ITypeAheadModel;
        newTimeStampVm(): ITimeStampVm;
    };
    export class TimeBookingResource implements ITimeBookingResource {
        constructor(private $requestSender) {}
                searchBookingsMultipleRequest(params,data) {         var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/SearchBookings";
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<ITimeBookingVm[]>("POST", url, data, "TimeBooking", "ITimeBookingVm[]", true);
        return dataRequest;
    }
            searchBookingsMultiple
(params,data) {     var request = this.        searchBookingsMultipleRequest(params,data);
    return this.$requestSender.requestValue(request);
}
browseMultipleRequest(params,data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/Browse";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITimeBookingVm[]>("POST", url, data, "TimeBooking", "ITimeBookingVm[]", true);
return dataRequest;
}
browseMultiple
(params,data) { var request = this.browseMultipleRequest(params,data);
return this.$requestSender.requestValue(request);
}
getTimebookingDetailRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/GetTimebookingDetail";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<ITimeBookingDetailVm>("GET", url, {}, "TimeBooking", "ITimeBookingDetailVm", false);
return dataRequest;
}
getTimebookingDetail
(params) { var request = this.getTimebookingDetailRequest(params);
return this.$requestSender.requestValue(request);
}
deleteRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/Delete";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("POST", url, {}, "TimeBooking", "any", false);
return dataRequest;
}
delete
(params) { var request = this.deleteRequest(params);
return this.$requestSender.requestValue(request);
}
saveBookingRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/SaveBooking";
var dataRequest = new DataRequest<boolean>("POST", url, data, "TimeBooking", "boolean", true);
return dataRequest;
}
saveBooking
(data) { var request = this.saveBookingRequest(data);
return this.$requestSender.requestValue(request);
}
reImportBookingsRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/ReImportBookings";
var dataRequest = new DataRequest<any>("POST", url, data, "TimeBooking", "any", true);
return dataRequest;
}
reImportBookings
(data) { var request = this.reImportBookingsRequest(data);
return this.$requestSender.requestValue(request);
}
triggerForceReloadRequest() { var url = this.$requestSender.getUrl('$proxy') + "/TimeBooking/TriggerForceReload";
var dataRequest = new DataRequest<number>("GET", url, {}, "TimeBooking", "number", false);
return dataRequest;
}
triggerForceReload
() { var request = this.triggerForceReloadRequest();
return this.$requestSender.requestValue(request);
}
public newTimeBookingVm(): ITimeBookingVm {
    return <ITimeBookingVm>{};
}
public newTimeBookingDetailVm(): ITimeBookingDetailVm {
    return <ITimeBookingDetailVm>{};
}
public newTimeBookingSearchCirteria(): ITimeBookingSearchCirteria {
    return <ITimeBookingSearchCirteria>{};
}
public newBrowseModel(): IBrowseModel {
    return <IBrowseModel>{};
}
public newBookingImportConditions(): IBookingImportConditions {
    return <IBookingImportConditions>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
public newTimeStampVm(): ITimeStampVm {
    return <ITimeStampVm>{};
}
}
    export interface PlannedStartUpdatePlannedStartParams {
        employeeNumber : string;
        vehicleNumber : string;
        startTime : Date;
        info? : string;
    }
    export interface PlannedStartUpdatePlannedStartJsonParams {
        json : string;
    }
    export interface IPlannedStartResource {
        updatePlannedStartRequest (params: PlannedStartUpdatePlannedStartParams ) : DataRequest<boolean>;
        updatePlannedStart(params: PlannedStartUpdatePlannedStartParams ) : angular.IPromise<DataResponse<boolean>>;
        updatePlannedStartJsonRequest (params: PlannedStartUpdatePlannedStartJsonParams ) : DataRequest<boolean>;
        updatePlannedStartJson(params: PlannedStartUpdatePlannedStartJsonParams ) : angular.IPromise<DataResponse<boolean>>;
    };
    export class PlannedStartResource implements IPlannedStartResource {
        constructor(private $requestSender) {}
                updatePlannedStartRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/PlannedStart/UpdatePlannedStart";
        if(angular.isDefined(params.employeeNumber)) {
            url = TriarcData.appendUrlParameter(url, "employeeNumber", encodeURIComponent(params.employeeNumber));
        }
        if(angular.isDefined(params.vehicleNumber)) {
            url = TriarcData.appendUrlParameter(url, "vehicleNumber", encodeURIComponent(params.vehicleNumber));
        }
        if(angular.isDefined(params.startTime)) {
            url = TriarcData.appendUrlParameter(url, "startTime", encodeURIComponent(params.startTime.toJSON()));
        }
        if(angular.isDefined(params.info)) {
            url = TriarcData.appendUrlParameter(url, "info", encodeURIComponent(params.info));
        }
        var dataRequest = new DataRequest<boolean>("GET", url, {}, "PlannedStart", "boolean", false);
        return dataRequest;
    }
            updatePlannedStart
(params) {     var request = this.        updatePlannedStartRequest(params);
    return this.$requestSender.requestValue(request);
}
updatePlannedStartJsonRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/PlannedStart/UpdatePlannedStartJson";
if(angular.isDefined(params.json)) {
    url = TriarcData.appendUrlParameter(url, "json", encodeURIComponent(params.json));
}
var dataRequest = new DataRequest<boolean>("GET", url, {}, "PlannedStart", "boolean", false);
return dataRequest;
}
updatePlannedStartJson
(params) { var request = this.updatePlannedStartJsonRequest(params);
return this.$requestSender.requestValue(request);
}
}
    export interface AbsenceGetParams {
        id : string;
    }
    export interface AbsenceDeleteParams {
        id : string;
    }
    export interface AbsenceBrowseEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface IAbsenceResource {
        createAbsenceRequest ( data: ICreateAbsenceVm) : DataRequest<any>;
        createAbsence( data: ICreateAbsenceVm) : angular.IPromise<DataResponse<any>>;
        saveAbsenceRequest ( data: ITimeBookingVm) : DataRequest<any>;
        saveAbsence( data: ITimeBookingVm) : angular.IPromise<DataResponse<any>>;
        getRequest (params: AbsenceGetParams ) : DataRequest<ITimeBookingDetailVm>;
        get(params: AbsenceGetParams ) : angular.IPromise<DataResponse<ITimeBookingDetailVm>>;
        deleteRequest (params: AbsenceDeleteParams ) : DataRequest<any>;
        delete(params: AbsenceDeleteParams ) : angular.IPromise<DataResponse<any>>;
        browseMultipleRequest (params: AbsenceBrowseEnumerableParams , data: IBrowseModel) : DataRequest<ITimeBookingVm[]>;
        browseMultiple(params: AbsenceBrowseEnumerableParams , data: IBrowseModel) : angular.IPromise<DataResponse<ITimeBookingVm[]>>;
        newTimeBookingDetailVm(): ITimeBookingDetailVm;
        newTimeBookingVm(): ITimeBookingVm;
        newCreateAbsenceVm(): ICreateAbsenceVm;
        newBrowseModel(): IBrowseModel;
        newTimeStampVm(): ITimeStampVm;
        newTypeAheadModel(): ITypeAheadModel;
    };
    export class AbsenceResource implements IAbsenceResource {
        constructor(private $requestSender) {}
                createAbsenceRequest(data) {         var url = this.$requestSender.getUrl('$proxy') + "/Absence/CreateAbsence";
        var dataRequest = new DataRequest<any>("POST", url, data, "Absence", "any", true);
        return dataRequest;
    }
            createAbsence
(data) {     var request = this.        createAbsenceRequest(data);
    return this.$requestSender.requestValue(request);
}
saveAbsenceRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Absence/SaveAbsence";
var dataRequest = new DataRequest<any>("POST", url, data, "Absence", "any", true);
return dataRequest;
}
saveAbsence
(data) { var request = this.saveAbsenceRequest(data);
return this.$requestSender.requestValue(request);
}
getRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Absence/Get";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<ITimeBookingDetailVm>("GET", url, {}, "Absence", "ITimeBookingDetailVm", false);
return dataRequest;
}
get
(params) { var request = this.getRequest(params);
return this.$requestSender.requestValue(request);
}
deleteRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Absence/Delete";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("POST", url, {}, "Absence", "any", false);
return dataRequest;
}
delete
(params) { var request = this.deleteRequest(params);
return this.$requestSender.requestValue(request);
}
browseMultipleRequest(params,data) { var url = this.$requestSender.getUrl('$proxy') + "/Absence/Browse";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITimeBookingVm[]>("POST", url, data, "Absence", "ITimeBookingVm[]", true);
return dataRequest;
}
browseMultiple
(params,data) { var request = this.browseMultipleRequest(params,data);
return this.$requestSender.requestValue(request);
}
public newTimeBookingDetailVm(): ITimeBookingDetailVm {
    return <ITimeBookingDetailVm>{};
}
public newTimeBookingVm(): ITimeBookingVm {
    return <ITimeBookingVm>{};
}
public newCreateAbsenceVm(): ICreateAbsenceVm {
    return <ICreateAbsenceVm>{};
}
public newBrowseModel(): IBrowseModel {
    return <IBrowseModel>{};
}
public newTimeStampVm(): ITimeStampVm {
    return <ITimeStampVm>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
}
    export interface ExpensesGetParams {
        id : number;
    }
    export interface ExpensesBrowseEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface ExpensesRemoveParams {
        id : number;
    }
    export interface IExpensesResource {
        createExpenseRequest ( data: ICreateExpenseVm) : DataRequest<any>;
        createExpense( data: ICreateExpenseVm) : angular.IPromise<DataResponse<any>>;
        saveExpenseRequest ( data: IExpenseVm) : DataRequest<any>;
        saveExpense( data: IExpenseVm) : angular.IPromise<DataResponse<any>>;
        getRequest (params: ExpensesGetParams ) : DataRequest<IExpenseVm>;
        get(params: ExpensesGetParams ) : angular.IPromise<DataResponse<IExpenseVm>>;
        browseMultipleRequest (params: ExpensesBrowseEnumerableParams , data: IBrowseModel) : DataRequest<IExpenseVm[]>;
        browseMultiple(params: ExpensesBrowseEnumerableParams , data: IBrowseModel) : angular.IPromise<DataResponse<IExpenseVm[]>>;
        removeRequest (params: ExpensesRemoveParams ) : DataRequest<any>;
        remove(params: ExpensesRemoveParams ) : angular.IPromise<DataResponse<any>>;
        newExpenseVm(): IExpenseVm;
        newCreateExpenseVm(): ICreateExpenseVm;
        newBrowseModel(): IBrowseModel;
        newTypeAheadModel(): ITypeAheadModel;
    };
    export class ExpensesResource implements IExpensesResource {
        constructor(private $requestSender) {}
                createExpenseRequest(data) {         var url = this.$requestSender.getUrl('$proxy') + "/Expenses/CreateExpense";
        var dataRequest = new DataRequest<any>("POST", url, data, "Expenses", "any", true);
        return dataRequest;
    }
            createExpense
(data) {     var request = this.        createExpenseRequest(data);
    return this.$requestSender.requestValue(request);
}
saveExpenseRequest(data) { var url = this.$requestSender.getUrl('$proxy') + "/Expenses/SaveExpense";
var dataRequest = new DataRequest<any>("POST", url, data, "Expenses", "any", true);
return dataRequest;
}
saveExpense
(data) { var request = this.saveExpenseRequest(data);
return this.$requestSender.requestValue(request);
}
getRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Expenses/Get";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<IExpenseVm>("GET", url, {}, "Expenses", "IExpenseVm", false);
return dataRequest;
}
get
(params) { var request = this.getRequest(params);
return this.$requestSender.requestValue(request);
}
browseMultipleRequest(params,data) { var url = this.$requestSender.getUrl('$proxy') + "/Expenses/Browse";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<IExpenseVm[]>("POST", url, data, "Expenses", "IExpenseVm[]", true);
return dataRequest;
}
browseMultiple
(params,data) { var request = this.browseMultipleRequest(params,data);
return this.$requestSender.requestValue(request);
}
removeRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Expenses/Remove";
if(angular.isDefined(params.id)) {
    url = TriarcData.appendUrlParameter(url, "id", encodeURIComponent(params.id));
}
var dataRequest = new DataRequest<any>("POST", url, {}, "Expenses", "any", false);
return dataRequest;
}
remove
(params) { var request = this.removeRequest(params);
return this.$requestSender.requestValue(request);
}
public newExpenseVm(): IExpenseVm {
    return <IExpenseVm>{};
}
public newCreateExpenseVm(): ICreateExpenseVm {
    return <ICreateExpenseVm>{};
}
public newBrowseModel(): IBrowseModel {
    return <IBrowseModel>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
}
    export interface ProjectSearchEnumerableParams {
        search : string;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface ProjectSearchCostCentersEnumerableParams {
        search : string;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface ProjectExistsParams {
        externalNr : string;
        type : EExternalProjectType;
    }
    export interface IProjectResource {
        searchMultipleRequest (params: ProjectSearchEnumerableParams ) : DataRequest<ITypeAheadModel[]>;
        searchMultiple(params: ProjectSearchEnumerableParams ) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        searchCostCentersMultipleRequest (params: ProjectSearchCostCentersEnumerableParams ) : DataRequest<ITypeAheadModel[]>;
        searchCostCentersMultiple(params: ProjectSearchCostCentersEnumerableParams ) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        existsRequest (params: ProjectExistsParams ) : DataRequest<boolean>;
        exists(params: ProjectExistsParams ) : angular.IPromise<DataResponse<boolean>>;
        newTypeAheadModel(): ITypeAheadModel;
    };
    export class ProjectResource implements IProjectResource {
        constructor(private $requestSender) {}
                searchMultipleRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/Project/Search";
        if(angular.isDefined(params.search)) {
            url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
        }
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<ITypeAheadModel[]>("POST", url, {}, "Project", "ITypeAheadModel[]", false);
        return dataRequest;
    }
            searchMultiple
(params) {     var request = this.        searchMultipleRequest(params);
    return this.$requestSender.requestValue(request);
}
searchCostCentersMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Project/SearchCostCenters";
if(angular.isDefined(params.search)) {
    url = TriarcData.appendUrlParameter(url, "search", encodeURIComponent(params.search));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITypeAheadModel[]>("POST", url, {}, "Project", "ITypeAheadModel[]", false);
return dataRequest;
}
searchCostCentersMultiple
(params) { var request = this.searchCostCentersMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
existsRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/Project/Exists";
if(angular.isDefined(params.externalNr)) {
    url = TriarcData.appendUrlParameter(url, "externalNr", encodeURIComponent(params.externalNr));
}
if(angular.isDefined(params.type)) {
    url = TriarcData.appendUrlParameter(url, "type", encodeURIComponent(params.type));
}
var dataRequest = new DataRequest<boolean>("POST", url, {}, "Project", "boolean", false);
return dataRequest;
}
exists
(params) { var request = this.existsRequest(params);
return this.$requestSender.requestValue(request);
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
}
    export interface TimeEntrtyTypeGetTimeEntryTypesEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface TimeEntrtyTypeGetMinimalEnumerableParams {
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface TimeEntrtyTypeGetMinimalOfKindEnumerableParams {
        kind : EKind;
        $skip? : number; $top? : number; $orderBy? : string; $filter? : string;
    }
    export interface ITimeEntrtyTypeResource {
        getTimeEntryTypesMultipleRequest (params: TimeEntrtyTypeGetTimeEntryTypesEnumerableParams ) : DataRequest<ITimeEntryTypeVm[]>;
        getTimeEntryTypesMultiple(params: TimeEntrtyTypeGetTimeEntryTypesEnumerableParams ) : angular.IPromise<DataResponse<ITimeEntryTypeVm[]>>;
        getMinimalMultipleRequest (params: TimeEntrtyTypeGetMinimalEnumerableParams ) : DataRequest<ITypeAheadModel[]>;
        getMinimalMultiple(params: TimeEntrtyTypeGetMinimalEnumerableParams ) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        getMinimalOfKindMultipleRequest (params: TimeEntrtyTypeGetMinimalOfKindEnumerableParams ) : DataRequest<ITypeAheadModel[]>;
        getMinimalOfKindMultiple(params: TimeEntrtyTypeGetMinimalOfKindEnumerableParams ) : angular.IPromise<DataResponse<ITypeAheadModel[]>>;
        newTimeEntryTypeVm(): ITimeEntryTypeVm;
        newTypeAheadModel(): ITypeAheadModel;
    };
    export class TimeEntrtyTypeResource implements ITimeEntrtyTypeResource {
        constructor(private $requestSender) {}
                getTimeEntryTypesMultipleRequest(params) {         var url = this.$requestSender.getUrl('$proxy') + "/TimeEntrtyType/GetTimeEntryTypes";
        if(angular.isDefined(params.$skip)) {
            url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
        }
        if(angular.isDefined(params.$top)) {
            url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
        }
        if(angular.isDefined(params.$orderBy)) {
            url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
        }
        if(angular.isDefined(params.$filter)) {
            url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
        }
        var dataRequest = new DataRequest<ITimeEntryTypeVm[]>("GET", url, {}, "TimeEntrtyType", "ITimeEntryTypeVm[]", false);
        return dataRequest;
    }
            getTimeEntryTypesMultiple
(params) {     var request = this.        getTimeEntryTypesMultipleRequest(params);
    return this.$requestSender.requestValue(request);
}
getMinimalMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/TimeEntrtyType/GetMinimal";
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITypeAheadModel[]>("GET", url, {}, "TimeEntrtyType", "ITypeAheadModel[]", false);
return dataRequest;
}
getMinimalMultiple
(params) { var request = this.getMinimalMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
getMinimalOfKindMultipleRequest(params) { var url = this.$requestSender.getUrl('$proxy') + "/TimeEntrtyType/GetMinimalOfKind";
if(angular.isDefined(params.kind)) {
    url = TriarcData.appendUrlParameter(url, "kind", encodeURIComponent(params.kind));
}
if(angular.isDefined(params.$skip)) {
    url = TriarcData.appendUrlParameter(url, "$skip", encodeURIComponent(params.$skip));
}
if(angular.isDefined(params.$top)) {
    url = TriarcData.appendUrlParameter(url, "$top", encodeURIComponent(params.$top));
}
if(angular.isDefined(params.$orderBy)) {
    url = TriarcData.appendUrlParameter(url, "$orderBy", encodeURIComponent(params.$orderBy));
}
if(angular.isDefined(params.$filter)) {
    url = TriarcData.appendUrlParameter(url, "$filter", encodeURIComponent(params.$filter));
}
var dataRequest = new DataRequest<ITypeAheadModel[]>("GET", url, {}, "TimeEntrtyType", "ITypeAheadModel[]", false);
return dataRequest;
}
getMinimalOfKindMultiple
(params) { var request = this.getMinimalOfKindMultipleRequest(params);
return this.$requestSender.requestValue(request);
}
public newTimeEntryTypeVm(): ITimeEntryTypeVm {
    return <ITimeEntryTypeVm>{};
}
public newTypeAheadModel(): ITypeAheadModel {
    return <ITypeAheadModel>{};
}
}
export interface ProxyContainer  {
    Version: IVersionResource;
    Image: IImageResource;
    Location: ILocationResource;
    Employee: IEmployeeResource;
    TimeValidation: ITimeValidationResource;
    TimeStamp: ITimeStampResource;
    Account: IAccountResource;
    Admin: IAdminResource;
    Role: IRoleResource;
    TimeSheet: ITimeSheetResource;
    ChangeTracking: IChangeTrackingResource;
    Config: IConfigResource;
    Import: IImportResource;
    Claim: IClaimResource;
    Licence: ILicenceResource;
    TimeRulesConfig: ITimeRulesConfigResource;
    TimeBooking: ITimeBookingResource;
    PlannedStart: IPlannedStartResource;
    Absence: IAbsenceResource;
    Expenses: IExpensesResource;
    Project: IProjectResource;
    TimeEntrtyType: ITimeEntrtyTypeResource;
}
var mod = angular.module("tlDataServices");
mod.provider('$proxy', function() {
    return {
        $get: ['$requestSender', ($requestSender) => {
            var proxy : ProxyContainer = {
                Version: new VersionResource($requestSender),
                Image: new ImageResource($requestSender),
                Location: new LocationResource($requestSender),
                Employee: new EmployeeResource($requestSender),
                TimeValidation: new TimeValidationResource($requestSender),
                TimeStamp: new TimeStampResource($requestSender),
                Account: new AccountResource($requestSender),
                Admin: new AdminResource($requestSender),
                Role: new RoleResource($requestSender),
                TimeSheet: new TimeSheetResource($requestSender),
                ChangeTracking: new ChangeTrackingResource($requestSender),
                Config: new ConfigResource($requestSender),
                Import: new ImportResource($requestSender),
                Claim: new ClaimResource($requestSender),
                Licence: new LicenceResource($requestSender),
                TimeRulesConfig: new TimeRulesConfigResource($requestSender),
                TimeBooking: new TimeBookingResource($requestSender),
                PlannedStart: new PlannedStartResource($requestSender),
                Absence: new AbsenceResource($requestSender),
                Expenses: new ExpensesResource($requestSender),
                Project: new ProjectResource($requestSender),
                TimeEntrtyType: new TimeEntrtyTypeResource($requestSender),
            };
            return proxy;
        }]
    };
});
